import { trigger, state, transition, style, animate } from '@angular/animations';
import * as i0 from '@angular/core';
import { inject, PLATFORM_ID, REQUEST, computed, Injectable, Inject, ElementRef, Renderer2, Input, ChangeDetectionStrategy, Component, signal, Directive, EventEmitter, Output, input, ViewChild, ContentChildren } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { of, Subscription, timer, BehaviorSubject, throttleTime } from 'rxjs';
import { shareReplay, map, delay, tap, mergeMap, scan } from 'rxjs/operators';
import { isPlatformBrowser, isPlatformServer, CommonModule, NgClass, AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { Platform } from '@angular/cdk/platform';
import { UAParser } from 'ua-parser-js';
import * as i1 from '@angular/cdk/dialog';
import * as i1$1 from '@angular/material/snack-bar';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import * as i1$2 from '@angular/material/icon';
import { MatIcon } from '@angular/material/icon';
import { LottieComponent } from 'ngx-lottie';
import { CdkCopyToClipboard } from '@angular/cdk/clipboard';
import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay';
import { MatIconButton, MatButton } from '@angular/material/button';
import * as i2 from '@angular/platform-browser';
import { CdkVirtualScrollViewport, CdkFixedSizeVirtualScroll, CdkVirtualForOf } from '@angular/cdk/scrolling';
import * as i1$3 from 'ngx-scrollbar';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgScrollbarCdkVirtualScroll } from 'ngx-scrollbar/cdk';
function LoadingComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ng-lottie", 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("height", ctx_r0.height())("width", ctx_r0.width())("options", ctx_r0.options);
  }
}
const _c0 = ["ac-clipboard", ""];
function CopyComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1, "Copied");
    i0.ɵɵelementEnd();
  }
}
const _c1 = [[["ac-card-header"]], [["ac-card-content"]], [["ac-card-actions"]]];
const _c2 = ["ac-card-header", "ac-card-content", "ac-card-actions"];
const _c3 = a0 => ({
  "is-dialog": a0
});
const _c4 = ["*"];
function CardHeaderComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function CardHeaderComponent_Conditional_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.back.emit());
    });
    i0.ɵɵelement(1, "ac-icon", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("absolute-icon-back", ctx_r1.absolutePositionIcons);
    i0.ɵɵadvance();
    i0.ɵɵproperty("size", 26);
  }
}
function CardHeaderComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.title, " ");
  }
}
function CardHeaderComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵlistener("click", function CardHeaderComponent_Conditional_6_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.close.emit());
    });
    i0.ɵɵelement(1, "ac-icon", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("absolute-icon-close", ctx_r1.absolutePositionIcons);
    i0.ɵɵadvance();
    i0.ɵɵproperty("size", 18);
  }
}
function CardHeaderComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.subtitle, " ");
  }
}
function CountdownTimerComponent_Case_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵtext(2);
    i0.ɵɵdomElementEnd();
    i0.ɵɵdomElementStart(3, "div", 4);
    i0.ɵɵtext(4, "Day");
    i0.ɵɵdomElementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.days());
  }
}
function CountdownTimerComponent_Case_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵtext(2);
    i0.ɵɵdomElementEnd();
    i0.ɵɵdomElementStart(3, "div", 4);
    i0.ɵɵtext(4, "Hour");
    i0.ɵɵdomElementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.hours());
  }
}
function CountdownTimerComponent_Case_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵtext(2);
    i0.ɵɵdomElementEnd();
    i0.ɵɵdomElementStart(3, "div", 4);
    i0.ɵɵtext(4, "Min");
    i0.ɵɵdomElementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.minutes());
  }
}
function CountdownTimerComponent_Case_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 0);
    i0.ɵɵconditionalCreate(1, CountdownTimerComponent_Case_0_Conditional_1_Template, 5, 1, "div", 2);
    i0.ɵɵconditionalCreate(2, CountdownTimerComponent_Case_0_Conditional_2_Template, 5, 1, "div", 2);
    i0.ɵɵconditionalCreate(3, CountdownTimerComponent_Case_0_Conditional_3_Template, 5, 1, "div", 2);
    i0.ɵɵdomElementStart(4, "div", 2)(5, "div", 3);
    i0.ɵɵtext(6);
    i0.ɵɵdomElementEnd();
    i0.ɵɵdomElementStart(7, "div", 4);
    i0.ɵɵtext(8, "Sec");
    i0.ɵɵdomElementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.includeDays() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.includeHours() ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.includeMinutes() ? 3 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.seconds());
  }
}
function CountdownTimerComponent_Case_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.days(), "d ");
  }
}
function CountdownTimerComponent_Case_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.hours(), "h ");
  }
}
function CountdownTimerComponent_Case_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.minutes(), "m ");
  }
}
function CountdownTimerComponent_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, CountdownTimerComponent_Case_1_Conditional_0_Template, 1, 1);
    i0.ɵɵconditionalCreate(1, CountdownTimerComponent_Case_1_Conditional_1_Template, 1, 1);
    i0.ɵɵconditionalCreate(2, CountdownTimerComponent_Case_1_Conditional_2_Template, 1, 1);
    i0.ɵɵtext(3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.includeDays() ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.includeHours() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.includeMinutes() ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.seconds(), "s ");
  }
}
function CountdownTimerComponent_Case_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate(ctx_r0.daysPadded());
  }
}
function CountdownTimerComponent_Case_2_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(":", ctx_r0.hoursPadded());
  }
}
function CountdownTimerComponent_Case_2_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate(ctx_r0.hoursPadded());
  }
}
function CountdownTimerComponent_Case_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, CountdownTimerComponent_Case_2_Conditional_2_Conditional_0_Template, 1, 1)(1, CountdownTimerComponent_Case_2_Conditional_2_Conditional_1_Template, 1, 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r0.includeDays() ? 0 : 1);
  }
}
function CountdownTimerComponent_Case_2_Conditional_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(":", ctx_r0.minutesPadded());
  }
}
function CountdownTimerComponent_Case_2_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate(ctx_r0.minutesPadded());
  }
}
function CountdownTimerComponent_Case_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, CountdownTimerComponent_Case_2_Conditional_3_Conditional_0_Template, 1, 1)(1, CountdownTimerComponent_Case_2_Conditional_3_Conditional_1_Template, 1, 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r0.includeHours() ? 0 : 1);
  }
}
function CountdownTimerComponent_Case_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(":", ctx_r0.secondsPadded());
  }
}
function CountdownTimerComponent_Case_2_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate(ctx_r0.secondsPadded());
  }
}
function CountdownTimerComponent_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 1);
    i0.ɵɵconditionalCreate(1, CountdownTimerComponent_Case_2_Conditional_1_Template, 1, 1);
    i0.ɵɵconditionalCreate(2, CountdownTimerComponent_Case_2_Conditional_2_Template, 2, 1);
    i0.ɵɵconditionalCreate(3, CountdownTimerComponent_Case_2_Conditional_3_Template, 2, 1);
    i0.ɵɵconditionalCreate(4, CountdownTimerComponent_Case_2_Conditional_4_Template, 1, 1)(5, CountdownTimerComponent_Case_2_Conditional_5_Template, 1, 1);
    i0.ɵɵdomElementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.includeDays() ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.includeHours() ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.includeMinutes() ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.includeMinutes() ? 4 : 5);
  }
}
const _c5 = [[["ac-infinite-scroll-end"]], [["ac-infinite-scroll-empty"]]];
const _c6 = ["ac-infinite-scroll-end", "ac-infinite-scroll-empty"];
const _c7 = a0 => ({
  $implicit: a0
});
function InfiniteScrollComponent_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function InfiniteScrollComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, InfiniteScrollComponent_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const data_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.itemTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c7, data_r1));
  }
}
function InfiniteScrollComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelement(1, "ac-loading", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("size", 50);
  }
}
function InfiniteScrollComponent_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function InfiniteScrollComponent_Conditional_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
function InfiniteScrollComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵconditionalCreate(1, InfiniteScrollComponent_Conditional_4_Conditional_1_Template, 1, 0)(2, InfiniteScrollComponent_Conditional_4_Conditional_2_Template, 1, 0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.dataArr.length ? 1 : 2);
  }
}
const _c8 = (a0, a1) => ({
  "is-selected": a0,
  "stretch": a1
});
const _c9 = [[["ac-single-select"]]];
const _c10 = ["ac-single-select"];
const fadeAnimation = (fadeInSpeed = 0.5, fadeOutSpeed = 0, triggerName = 'fade') => trigger(triggerName, [state('in', style({
  opacity: 1
})), transition(':enter', [style({
  opacity: 0
}), animate(`${fadeInSpeed}s`, style({
  opacity: 1
}))]), transition(':leave', animate(`${fadeOutSpeed}s`, style({
  opacity: 0
})))]);
let DeviceService = /*#__PURE__*/(() => {
  class DeviceService {
    get _isBrowser() {
      return isPlatformBrowser(this._platform);
    }
    /**
     * Returns whether the device the user is on is a mobile device (android or ios)
     */
    get isMobilePlatform() {
      return !this._isBrowser ? this._deviceProperties?.device?.type === 'mobile' : this._devicePlatform.IOS || this._devicePlatform.ANDROID;
    }
    /**
     * Returns properties of the device based on the user agent provided by the request header. Only accessible in a server
     * side rendered context.
     */
    get properties() {
      return !this._isBrowser ? this._deviceProperties : null;
    }
    /**
     * Whether the device is known or whether the device is in CSR context.
     */
    get deviceKnownOrIsBrowser() {
      return !!this._deviceProperties || this._isBrowser;
    }
    constructor() {
      this._breakpointObserver = inject(BreakpointObserver);
      this._platform = inject(PLATFORM_ID);
      this._devicePlatform = inject(Platform);
      this._request = inject(REQUEST, {
        optional: true
      });
      // For some reason, the user-agent header is just 'Google' when read from App Hosting SSR app. Not sure if the Google FE
      // sanitizing the agent somehow, but we manually have to set the UA ourselves to get it.
      const userAgent = this._request?.headers?.get?.('X-Ripabet-UA') ?? this._request?.headers?.get?.('user-agent');
      this._deviceProperties = userAgent && userAgent !== 'Google' ? UAParser(userAgent) : null;
      const deviceViewPortChange$ = this._isBrowser ? this._deviceViewportChangeBrowser$() : this._deviceViewportChangeServer$();
      this.deviceViewPortChange$ = deviceViewPortChange$.pipe(
      // We do this so we can get an immediate render for device based views without a small lag that causes UI jumps
      shareReplay(1));
      // These should be defined in the constructor to enforce ordering. If we define it at the class level, the device
      // properties will not be rendered on the server side before the device viewport defaults which will cause the
      // mobile rendering to not work.
      this.deviceViewportChange = toSignal(this.deviceViewPortChange$);
      this.isMobile$ = this.deviceViewPortChange$.pipe(map(res => res.isMobile));
      this.isNotMobile$ = this.isMobile$.pipe(map(isMobile => !isMobile));
      this.isXlScreen$ = this.deviceViewPortChange$.pipe(map(res => res.isXlScreen));
      this.ltXlScreen$ = this.deviceViewPortChange$.pipe(map(res => res.ltXlScreen));
      this.ltLgScreen$ = this.deviceViewPortChange$.pipe(map(res => res.ltLgScreen));
      this.gtMdScreen$ = this.deviceViewPortChange$.pipe(map(res => res.gtMdScreen));
      this.ltMdScreen$ = this.deviceViewPortChange$.pipe(map(res => res.ltMdScreen));
      this.gtSmScreen$ = this.deviceViewPortChange$.pipe(map(res => res.gtSmScreen));
      this.isSmScreen$ = this.deviceViewPortChange$.pipe(map(res => res.isSmScreen));
      this.gtXsScreen$ = this.deviceViewPortChange$.pipe(map(res => res.gtXsScreen));
      this.isXsScreen$ = this.deviceViewPortChange$.pipe(map(res => res.isXsScreen));
      this.isMobile = computed(() => this.deviceViewportChange().isMobile);
      this.isNotMobile = computed(() => !this.deviceViewportChange().isMobile);
      this.isXlScreen = computed(() => this.deviceViewportChange().isXlScreen);
      this.ltXlScreen = computed(() => this.deviceViewportChange().ltXlScreen);
      this.ltLgScreen = computed(() => this.deviceViewportChange().ltLgScreen);
      this.gtMdScreen = computed(() => this.deviceViewportChange().gtMdScreen);
      this.ltMdScreen = computed(() => this.deviceViewportChange().ltMdScreen);
      this.gtSmScreen = computed(() => this.deviceViewportChange().gtSmScreen);
      this.isSmScreen = computed(() => this.deviceViewportChange().isSmScreen);
      this.gtXsScreen = computed(() => this.deviceViewportChange().gtXsScreen);
      this.isXsScreen = computed(() => this.deviceViewportChange().isXsScreen);
    }
    deviceViewportChangeCustom$(mediaQueryStr, defaultValue = false) {
      return this._breakpointObserver.observe([mediaQueryStr]).pipe(map(res => res.breakpoints[mediaQueryStr] || defaultValue));
    }
    _deviceViewportChangeServer$() {
      return of({
        isMobile: this.isMobilePlatform,
        isMobilePortrait: this.isMobilePlatform,
        isMobileLandscape: false,
        isTablet: false,
        isTabletPortrait: false,
        isTabletLandscape: false,
        isXlScreen: false,
        ltXlScreen: this.isMobilePlatform,
        isLgScreen: !this.isMobilePlatform,
        ltLgScreen: this.isMobilePlatform,
        gtMdScreen: !this.isMobilePlatform,
        isMdScreen: false,
        ltMdScreen: this.isMobilePlatform,
        gtSmScreen: !this.isMobilePlatform,
        isSmScreen: false,
        gtXsScreen: !this.isMobilePlatform,
        isXsScreen: this.isMobilePlatform
      });
    }
    _deviceViewportChangeBrowser$() {
      return this._breakpointObserver.observe([Breakpoints.Handset, Breakpoints.HandsetPortrait, Breakpoints.HandsetLandscape, Breakpoints.Tablet, Breakpoints.TabletPortrait, Breakpoints.TabletLandscape, Breakpoints.XLarge, Breakpoints.Large, Breakpoints.Medium, Breakpoints.Small, Breakpoints.XSmall]).pipe(map(result => {
        return {
          isMobile: result.breakpoints[Breakpoints.HandsetPortrait] || result.breakpoints[Breakpoints.HandsetLandscape],
          isMobilePortrait: result.breakpoints[Breakpoints.HandsetPortrait],
          isMobileLandscape: result.breakpoints[Breakpoints.HandsetLandscape],
          isTablet: result.breakpoints[Breakpoints.TabletPortrait] || result.breakpoints[Breakpoints.TabletLandscape],
          isTabletPortrait: result.breakpoints[Breakpoints.TabletPortrait],
          isTabletLandscape: result.breakpoints[Breakpoints.TabletLandscape],
          isXlScreen: result.breakpoints[Breakpoints.XLarge],
          ltXlScreen: result.breakpoints[Breakpoints.Large] || result.breakpoints[Breakpoints.Medium] || result.breakpoints[Breakpoints.Small] || result.breakpoints[Breakpoints.XSmall],
          isLgScreen: result.breakpoints[Breakpoints.Large],
          ltLgScreen: result.breakpoints[Breakpoints.Medium] || result.breakpoints[Breakpoints.Small] || result.breakpoints[Breakpoints.XSmall],
          gtMdScreen: result.breakpoints[Breakpoints.XLarge] || result.breakpoints[Breakpoints.Large],
          isMdScreen: result.breakpoints[Breakpoints.Medium],
          ltMdScreen: result.breakpoints[Breakpoints.Small] || result.breakpoints[Breakpoints.XSmall],
          gtSmScreen: result.breakpoints[Breakpoints.XLarge] || result.breakpoints[Breakpoints.Large] || result.breakpoints[Breakpoints.Medium],
          isSmScreen: result.breakpoints[Breakpoints.Small],
          gtXsScreen: result.breakpoints[Breakpoints.XLarge] || result.breakpoints[Breakpoints.Large] || result.breakpoints[Breakpoints.Medium] || result.breakpoints[Breakpoints.Small],
          isXsScreen: result.breakpoints[Breakpoints.XSmall]
        };
      }));
    }
    static {
      this.ɵfac = function DeviceService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DeviceService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: DeviceService,
        factory: DeviceService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return DeviceService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Arcade wrapper for the Angular CDK dialog api. Sets defaults that shape the dialog to the Arcade design system.
 **/
let DialogService = /*#__PURE__*/(() => {
  class DialogService {
    constructor(_dialog, _platformId) {
      this._dialog = _dialog;
      this._platformId = _platformId;
    }
    open(componentOrTemplateRef, config) {
      if (isPlatformServer(this._platformId)) {
        return this._dialogRefMock();
      }
      const dialogConfig = config ?? {};
      dialogConfig.backdropClass = (typeof dialogConfig?.backdropClass === 'string' ? [dialogConfig.backdropClass] : dialogConfig?.backdropClass ?? []).concat(['ac-dialog-backdrop']);
      dialogConfig.panelClass = (typeof config?.panelClass === 'string' ? [config.panelClass] : config?.panelClass ?? []).concat(['ac-dialog-panel']);
      return this._dialog.open(componentOrTemplateRef, dialogConfig);
    }
    getDialogRefById(id) {
      return this._dialog.getDialogById(id);
    }
    _dialogRefMock() {
      return {
        backdropClick: of(null),
        close(result, options) {},
        closed: of(null),
        componentInstance: null,
        componentRef: null,
        config: null,
        containerInstance: null,
        disableClose: undefined,
        id: 'dialog-ref-mock',
        keydownEvents: of(null),
        outsidePointerEvents: of(null),
        overlayRef: null,
        addPanelClass(classes) {
          return null;
        },
        removePanelClass(classes) {
          return null;
        },
        updatePosition() {
          return null;
        },
        updateSize(width, height) {
          return null;
        }
      };
    }
    static {
      this.ɵfac = function DialogService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DialogService)(i0.ɵɵinject(i1.Dialog), i0.ɵɵinject(PLATFORM_ID));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: DialogService,
        factory: DialogService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return DialogService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IconComponent = /*#__PURE__*/(() => {
  class IconComponent {
    constructor() {
      this._elementRef = inject(ElementRef);
      this._renderer = inject(Renderer2);
      /**
       * The size of the icon
       */
      this.size = 24;
      this.useWidth = false;
    }
    ngAfterViewInit() {
      // Angular material applies icon sizes to the icon buttons and menu item icons, and they have their own overrides.
      // However, since we wrapped mat-icon with this ac-icon and manually control the size, the material overrides for
      // those icon sizes override our ac-icon size. So here, we are setting those overrideable icon size variables so
      // that we can continue to control the icon sizes directly from ac-icon instead of those component overrides.
      this._renderer.setProperty(this._elementRef.nativeElement, 'style', `
      --mat-icon-button-icon-size: ${this.size}px;
      --mat-menu-item-icon-size: ${this.size}px;
    `);
    }
    static {
      this.ɵfac = function IconComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IconComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: IconComponent,
        selectors: [["ac-icon"]],
        inputs: {
          iconKey: "iconKey",
          size: "size",
          useWidth: "useWidth"
        },
        decls: 2,
        vars: 5,
        consts: [[1, "ac-flex", "ac-ctr"], [1, "ac-ctr", 2, "display", "flex", 3, "svgIcon"]],
        template: function IconComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "mat-icon", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("width", ctx.size + "px")("height", ctx.useWidth ? "auto" : ctx.size + "px");
            i0.ɵɵadvance();
            i0.ɵɵproperty("svgIcon", ctx.iconKey);
          }
        },
        dependencies: [CommonModule, MatIcon],
        styles: ["[_nghost-%COMP%]{display:contents}"],
        changeDetection: 0
      });
    }
  }
  return IconComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AlertComponent = /*#__PURE__*/(() => {
  class AlertComponent {
    constructor(data, matSnackBarRef) {
      this.data = data;
      this.matSnackBarRef = matSnackBarRef;
    }
    onSnackbarClick() {
      this.matSnackBarRef.dismiss();
    }
    static {
      this.ɵfac = function AlertComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AlertComponent)(i0.ɵɵdirectiveInject(MAT_SNACK_BAR_DATA), i0.ɵɵdirectiveInject(i1$1.MatSnackBarRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AlertComponent,
        selectors: [["app-alerts"]],
        decls: 8,
        vars: 5,
        consts: [[1, "alerts", 3, "click", "ngClass"], [1, "text-section", "ac-flex-col", "ac-gap-xs"], [1, "ac-flex", "ac-algn-ctr", "ac-gap-xs"], [1, "alert-icon", 3, "iconKey", "size"], [1, "title", "ac-title-lg"], [1, "ac-body-lg"]],
        template: function AlertComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("click", function AlertComponent_Template_div_click_0_listener() {
              return ctx.onSnackbarClick();
            });
            i0.ɵɵelementStart(1, "section", 1)(2, "div", 2);
            i0.ɵɵelement(3, "ac-icon", 3);
            i0.ɵɵelementStart(4, "div", 4);
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(6, "div", 5);
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", "alerts--" + ctx.data.alertType);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("iconKey", ctx.data.iconKey)("size", 24);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.data.title);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.data.message);
          }
        },
        dependencies: [NgClass, IconComponent],
        styles: ["[_nghost-%COMP%]{display:block}[_nghost-%COMP%]   .alerts[_ngcontent-%COMP%]   .text-section[_ngcontent-%COMP%]{max-width:400px}@media (max-width: 599px) and (orientation: portrait),(max-width: 959px) and (orientation: landscape){[_nghost-%COMP%]   .alerts[_ngcontent-%COMP%]   .text-section[_ngcontent-%COMP%]{max-width:calc(100% - 32px)}}[_nghost-%COMP%]   .alerts[_ngcontent-%COMP%]   .text-section[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{line-height:1.5rem}"],
        changeDetection: 0
      });
    }
  }
  return AlertComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AlertService = /*#__PURE__*/(() => {
  class AlertService {
    constructor(_snackBar) {
      this._snackBar = _snackBar;
      this.DefaultTimeoutMilli = 8 * 1000;
    }
    notify(title, message, alertType, config) {
      this._snackBar.openFromComponent(AlertComponent, {
        data: {
          title,
          message,
          alertType,
          iconKey: config?.iconKey ?? this._getIconKeyDefault(alertType)
        },
        verticalPosition: 'top',
        horizontalPosition: 'end',
        duration: config?.timeout ?? this.DefaultTimeoutMilli,
        panelClass: [alertType]
      });
    }
    notifySuccess(title, message, config) {
      this.notify(title, message, AlertType.Success, config);
    }
    notifyInfo(title, message, config) {
      this.notify(title, message, AlertType.Info, config);
    }
    notifyWarning(title, message, config) {
      this.notify(title, message, AlertType.Warning, config);
    }
    notifyDanger(title, message, config) {
      this.notify(title, message, AlertType.Danger, config);
    }
    _getIconKeyDefault(alertType) {
      switch (alertType) {
        case AlertType.Success:
          return 'hr:checkmark_circle';
        case AlertType.Info:
          return 'hr:info';
        case AlertType.Warning:
        case AlertType.Danger:
          return 'hr:warning';
      }
    }
    static {
      this.ɵfac = function AlertService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AlertService)(i0.ɵɵinject(i1$1.MatSnackBar));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AlertService,
        factory: AlertService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AlertService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
// These string values should match the icon keys for the specific type we want
var AlertType = /*#__PURE__*/function (AlertType) {
  AlertType["Success"] = "ac-success";
  AlertType["Warning"] = "ac-warning";
  AlertType["Info"] = "ac-info";
  AlertType["Danger"] = "ac-danger";
  return AlertType;
}(AlertType || {});
let LoadingComponent = /*#__PURE__*/(() => {
  class LoadingComponent {
    constructor() {
      this._platform = inject(PLATFORM_ID);
      this.delayShowMs = 0;
      this.size = 50;
      this.mobileSize = this.size;
      this.type = 'spinner';
      this.width = signal('');
      this.height = signal('');
    }
    ngOnInit() {
      this.width.set(`${this.size}px`);
      this.height.set(`${this.size}px`);
      this.options = {
        path: this.type === 'logo' ? 'https://cdn.ripabet.com/animations/loading_logo.json' : 'https://cdn.ripabet.com/animations/loading.json'
      };
      this.show$ = isPlatformServer(this._platform) ? of(false) : of(true).pipe(delay(this.delayShowMs));
    }
    static {
      this.ɵfac = function LoadingComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LoadingComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LoadingComponent,
        selectors: [["ac-loading"]],
        inputs: {
          delayShowMs: "delayShowMs",
          size: "size",
          mobileSize: "mobileSize",
          type: "type"
        },
        decls: 2,
        vars: 3,
        consts: [["ngSkipHydration", "", 3, "height", "width", "options"]],
        template: function LoadingComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, LoadingComponent_Conditional_0_Template, 1, 3, "ng-lottie", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 1, ctx.show$) ? 0 : -1);
          }
        },
        dependencies: [LottieComponent, AsyncPipe],
        styles: ["[_nghost-%COMP%]{display:contents}ng-lottie[_ngcontent-%COMP%]{display:contents}"]
      });
    }
  }
  return LoadingComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ButtonLoadingDirective = /*#__PURE__*/(() => {
  class ButtonLoadingDirective {
    get buttonEl() {
      return this._el.nativeElement;
    }
    constructor(_el, _renderer, _viewContainerRef, _platformId) {
      this._el = _el;
      this._renderer = _renderer;
      this._viewContainerRef = _viewContainerRef;
      this._platformId = _platformId;
      this.loading = false;
      this._loadingComponent = null;
    }
    ngOnChanges() {
      // See below comment on this._spinnerContainer.appendChild() for why this is needed
      if (isPlatformBrowser(this._platformId)) {
        if (this.loading) {
          this._setLoadingSpinner(true);
        } else {
          this._setLoadingSpinner(false);
        }
      }
    }
    _setLoadingSpinner(enable) {
      if (!this._spinnerContainer && enable) {
        this._loadingComponent = this._viewContainerRef.createComponent(LoadingComponent);
        this._loadingComponent.instance.size = this.buttonEl.offsetHeight * .5;
        this._spinnerContainer = this._renderer.createElement('span');
        this._renderer.addClass(this._spinnerContainer, 'ac-button-loading-spinner');
        this._renderer.setProperty(this._spinnerContainer, 'style', '--mdc-icon-button-icon-size: 100%');
        // TODO: This specific line causes an error when the consumer sets the loading input to true initially. The error happens on the client side
        //       due to a "DOM Element expected" error, but the stack trace further indicates it's something with SSR hydration mismatch.
        //       It is uncertain whether it's a bug with Angular or something else, but as a hack, we add a browser check in ngOnChanges and only
        //       execute the spinner logic in CSR until we can further look into this.
        this._spinnerContainer.appendChild(this._loadingComponent.location.nativeElement);
        this.buttonEl.classList.add('ac-button-loading');
        this.buttonEl.appendChild(this._spinnerContainer);
      } else if (this._spinnerContainer) {
        this.buttonEl.classList.remove('ac-button-loading');
        this._loadingComponent?.destroy();
        this._loadingComponent = null;
        this._spinnerContainer?.remove();
        this._spinnerContainer = null;
      }
    }
    static {
      this.ɵfac = function ButtonLoadingDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ButtonLoadingDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(PLATFORM_ID));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: ButtonLoadingDirective,
        selectors: [["button", "mat-button", "", "loading", ""], ["button", "mat-raised-button", "", "loading", ""], ["button", "mat-stroked-button", "", "loading", ""], ["button", "mat-flat-button", "", "loading", ""], ["button", "mat-icon-button", "", "loading", ""], ["button", "mat-fab", "", "loading", ""], ["button", "mat-mini-fab", "", "loading", ""]],
        inputs: {
          loading: "loading"
        },
        features: [i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return ButtonLoadingDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CopyComponent = /*#__PURE__*/(() => {
  class CopyComponent {
    constructor(_cdr) {
      this._cdr = _cdr;
      this.text = '';
      this.showCopyTooltip = false;
      this._timeoutId = null;
    }
    showTooltip() {
      if (this._timeoutId) {
        clearTimeout(this._timeoutId);
        this._timeoutId = null;
      }
      this.showCopyTooltip = false;
      // Do this so that the tooltip re-renders when clicked in succession for better UX
      setTimeout(() => {
        this.showCopyTooltip = true;
        this._cdr.markForCheck();
      }, 50);
      this._timeoutId = setTimeout(() => {
        this.showCopyTooltip = false;
        this._cdr.markForCheck();
      }, 3000);
    }
    ngOnDestroy() {
      if (this._timeoutId) {
        clearTimeout(this._timeoutId);
      }
    }
    static {
      this.ɵfac = function CopyComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CopyComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CopyComponent,
        selectors: [["", "ac-clipboard", ""]],
        inputs: {
          text: "text"
        },
        attrs: _c0,
        decls: 4,
        vars: 5,
        consts: [["trigger", "cdkOverlayOrigin"], ["mat-icon-button", "", "cdkOverlayOrigin", "", 1, "copy-button", 3, "click", "cdkCopyToClipboard"], ["iconKey", "hr:copy", 3, "size"], ["cdkConnectedOverlay", "", 3, "cdkConnectedOverlayOrigin", "cdkConnectedOverlayOpen", "cdkConnectedOverlayOffsetY"], [1, "copy-tooltip", "ac-pd-xs-sm", "ac-body-sm"]],
        template: function CopyComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "button", 1, 0);
            i0.ɵɵlistener("click", function CopyComponent_Template_button_click_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.showTooltip());
            });
            i0.ɵɵelement(2, "ac-icon", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, CopyComponent_ng_template_3_Template, 2, 0, "ng-template", 3);
          }
          if (rf & 2) {
            const trigger_r2 = i0.ɵɵreference(1);
            i0.ɵɵproperty("cdkCopyToClipboard", ctx.text);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("size", 16);
            i0.ɵɵadvance();
            i0.ɵɵproperty("cdkConnectedOverlayOrigin", trigger_r2)("cdkConnectedOverlayOpen", ctx.showCopyTooltip)("cdkConnectedOverlayOffsetY", 4);
          }
        },
        dependencies: [CdkCopyToClipboard, CdkConnectedOverlay, CdkOverlayOrigin, IconComponent, MatIconButton],
        styles: [".copy-button[_ngcontent-%COMP%]{--mat-icon-button-state-layer-size: 24px}.copy-tooltip[_ngcontent-%COMP%]{display:inline-block;border-radius:var(--ac-border-radius-md);color:var(--ac-on-info);background-color:var(--ac-info)}"],
        changeDetection: 0
      });
    }
  }
  return CopyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Check if an element is a descendant of an ancestor with a specific class
 * @param element The element to check
 * @param ancestorClass The class of the ancestor to check for
 * @returns true if the element is a descendant of an ancestor with the specified class, false otherwise
 */
const isDescendant = (element, ancestorClass) => {
  let heightSearched = 0;
  let parent = element.parentNode;
  let isDescendant = false;
  // Walk up at most a height of 100 to ensure we don't get stuck in an infinite loop
  while (parent && !isDescendant && ++heightSearched <= 100) {
    if (parent?.classList?.contains(ancestorClass)) {
      isDescendant = true;
    }
    parent = parent.parentNode;
  }
  return isDescendant;
};
let CardComponent = /*#__PURE__*/(() => {
  class CardComponent {
    constructor(device, _cdr, _elementRef) {
      this.device = device;
      this._cdr = _cdr;
      this._elementRef = _elementRef;
      this.isDialog = false;
    }
    ngAfterViewInit() {
      setTimeout(() => {
        if (isDescendant(this._elementRef.nativeElement, 'cdk-dialog-container')) {
          this.isDialog = true;
          this._cdr.markForCheck();
        }
      });
    }
    static {
      this.ɵfac = function CardComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CardComponent)(i0.ɵɵdirectiveInject(DeviceService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CardComponent,
        selectors: [["ac-card"]],
        ngContentSelectors: _c2,
        decls: 4,
        vars: 3,
        consts: [[1, "card-container", "ac-flex-col", "ac-gap-lg", 3, "ngClass"]],
        template: function CardComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c1);
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵprojection(2, 1);
            i0.ɵɵprojection(3, 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c3, ctx.isDialog));
          }
        },
        dependencies: [NgClass],
        styles: ["[_nghost-%COMP%]{font-family:Geist,sans-serif;display:contents}.card-container[_ngcontent-%COMP%]{position:relative;background:var(--ac-card-background);padding:var(--ac-card-padding);border-radius:var(--ac-card-radius);width:var(--ac-card-width)}@media (max-width: 599px){.card-container[_ngcontent-%COMP%]{padding:var(--ac-card-padding-mobile)}}.card-container.is-dialog[_ngcontent-%COMP%]{max-height:calc(100vh - var(--ac-card-padding) * 2);max-height:calc(100dvh - var(--ac-card-padding) * 2);overflow-y:auto;scrollbar-width:none;-ms-overflow-style:none}.card-container.is-dialog[_ngcontent-%COMP%]::-webkit-scrollbar{background:transparent;width:0px}@media (max-width: 599px){.card-container.is-dialog[_ngcontent-%COMP%]{width:calc(100vw - var(--ac-card-padding-mobile) * 2);width:calc(100dvw - var(--ac-card-padding-mobile) * 2);height:calc(100vh - var(--ac-card-padding-mobile) * 2);height:calc(100dvh - var(--ac-card-padding-mobile) * 2);max-height:calc(100vh - var(--ac-card-padding-mobile) * 2);max-height:calc(100dvh - var(--ac-card-padding-mobile) * 2);border-radius:0}}"],
        changeDetection: 0
      });
    }
  }
  return CardComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CardHeaderComponent = /*#__PURE__*/(() => {
  class CardHeaderComponent {
    constructor() {
      this.device = inject(DeviceService);
      this.title = '';
      this.subtitle = '';
      this.hideBack = true;
      this.hideClose = false;
      /**
       * This flag absolutely positions the close and back icon if they exist. This allows for projected content to be take up
       * the full width of the modal (aside padding) and center as need regardless of the combination of icons.
       */
      this.absolutePositionIcons = false;
      this.back = new EventEmitter();
      this.close = new EventEmitter();
    }
    static {
      this.ɵfac = function CardHeaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CardHeaderComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CardHeaderComponent,
        selectors: [["ac-card-header"]],
        inputs: {
          title: "title",
          subtitle: "subtitle",
          hideBack: "hideBack",
          hideClose: "hideClose",
          absolutePositionIcons: "absolutePositionIcons"
        },
        outputs: {
          back: "back",
          close: "close"
        },
        ngContentSelectors: _c4,
        decls: 8,
        vars: 4,
        consts: [[1, "ac-flex-col", "ac-gap-sm"], [1, "ac-flex", "ac-sp-btw"], [1, "card-header-left", "ac-flex", "ac-gap-md"], ["mat-icon-button", "", 1, "card-header-icon", "ac-icon-btn-sm", 3, "absolute-icon-back"], [1, "ac-headline-md"], ["mat-icon-button", "", 1, "card-header-icon", "ac-icon-btn-sm", 3, "absolute-icon-close"], [1, "subtitle", "ac-body-md"], ["mat-icon-button", "", 1, "card-header-icon", "ac-icon-btn-sm", 3, "click"], ["iconKey", "hr:arrow_left", 3, "size"], ["iconKey", "hr:xmark", 1, "card-header-icon", 3, "size"]],
        template: function CardHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵconditionalCreate(3, CardHeaderComponent_Conditional_3_Template, 2, 3, "button", 3);
            i0.ɵɵconditionalCreate(4, CardHeaderComponent_Conditional_4_Template, 2, 1, "div", 4);
            i0.ɵɵprojection(5);
            i0.ɵɵelementEnd();
            i0.ɵɵconditionalCreate(6, CardHeaderComponent_Conditional_6_Template, 2, 3, "button", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵconditionalCreate(7, CardHeaderComponent_Conditional_7_Template, 2, 1, "div", 6);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(!ctx.hideBack ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.title ? 4 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(!ctx.hideClose || ctx.device.isXsScreen() ? 6 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.subtitle ? 7 : -1);
          }
        },
        dependencies: [IconComponent, MatIconButton],
        styles: [".card-header-left[_ngcontent-%COMP%]{width:100%}.subtitle[_ngcontent-%COMP%]{margin-top:var(--ac-spacing-xs);color:var(--mat-sys-on-surface-variant)}.card-header-icon[_ngcontent-%COMP%]{background-color:var(--ac-tint-highest)}.absolute-icon-back[_ngcontent-%COMP%]{position:absolute;top:var(--ac-card-padding);left:var(--ac-card-padding)}.absolute-icon-close[_ngcontent-%COMP%]{position:absolute;top:var(--ac-card-padding);right:var(--ac-card-padding);margin-left:var(--ac-spacing-md)}"]
      });
    }
  }
  return CardHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CardContentComponent = /*#__PURE__*/(() => {
  class CardContentComponent {
    static {
      this.ɵfac = function CardContentComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CardContentComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CardContentComponent,
        selectors: [["ac-card-content"]],
        ngContentSelectors: _c4,
        decls: 1,
        vars: 0,
        template: function CardContentComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2
      });
    }
  }
  return CardContentComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CardActionsComponent = /*#__PURE__*/(() => {
  class CardActionsComponent {
    static {
      this.ɵfac = function CardActionsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CardActionsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CardActionsComponent,
        selectors: [["ac-card-actions"]],
        ngContentSelectors: _c4,
        decls: 1,
        vars: 0,
        template: function CardActionsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        styles: ["[_nghost-%COMP%]{display:flex;flex-direction:column;gap:var(--ac-spacing-lg);width:100%}"]
      });
    }
  }
  return CardActionsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CountdownTimerComponent = /*#__PURE__*/(() => {
  class CountdownTimerComponent {
    constructor(_ngZone, _changeDetectorRef, _platformId) {
      this._ngZone = _ngZone;
      this._changeDetectorRef = _changeDetectorRef;
      this._platformId = _platformId;
      this.endTime = input(new Date());
      this.mode = input('number');
      this.format = input('DHMS');
      this.stopped = new EventEmitter();
      this.days = signal(0);
      this.hours = signal(0);
      this.minutes = signal(0);
      this.seconds = signal(0);
      this.daysPadded = computed(() => this.days() < 10 ? '0' + this.days() : this.days().toString());
      this.hoursPadded = computed(() => this.hours() < 10 ? '0' + this.hours() : this.hours().toString());
      this.minutesPadded = computed(() => this.minutes() < 10 ? '0' + this.minutes() : this.minutes().toString());
      this.secondsPadded = computed(() => this.seconds() < 10 ? '0' + this.seconds() : this.seconds().toString());
      this.includeDays = computed(() => this.format() === 'DHMS');
      this.includeHours = computed(() => this.format() === 'DHMS' || this.format() === 'HMS');
      this.includeMinutes = computed(() => this.format() !== 'S');
      this._timeUntilEndMS = 0;
      this._timerSubscription = Subscription.EMPTY;
    }
    // May want to change this to ngOnChanges
    ngOnInit() {
      if (isPlatformBrowser(this._platformId)) {
        const now = new Date();
        const endDate = this.endTime() instanceof Date ? this.endTime() : new Date(this.endTime());
        this._timeUntilEndMS = endDate.getTime() - now.getTime();
        this._ngZone.runOutsideAngular(() => {
          this._timerSubscription = timer(0, 1000).subscribe(() => this._updateClock());
        });
      }
    }
    ngOnDestroy() {
      this._timerSubscription.unsubscribe();
    }
    _updateClock() {
      this._timeUntilEndMS -= 1000;
      this.days.set(this._timeUntilEndMS > 0 ? Math.floor(this._timeUntilEndMS / 86400e3) : 0);
      this.hours.set(this._timeUntilEndMS > 0 ? Math.floor(this._timeUntilEndMS / (60 * 60e3) % 24) : 0);
      this.minutes.set(this._timeUntilEndMS > 0 ? Math.floor(this._timeUntilEndMS / 60e3 % 60) : 0);
      this.seconds.set(this._timeUntilEndMS > 0 ? Math.floor(this._timeUntilEndMS / 1e3 % 60) : 0);
      if (this._timeUntilEndMS <= 0) {
        this._timerSubscription.unsubscribe();
        this.stopped.emit();
        this._changeDetectorRef.markForCheck();
        return;
      }
    }
    static {
      this.ɵfac = function CountdownTimerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CountdownTimerComponent)(i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(PLATFORM_ID));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CountdownTimerComponent,
        selectors: [["ac-countdown-timer"]],
        inputs: {
          endTime: [1, "endTime"],
          mode: [1, "mode"],
          format: [1, "format"]
        },
        outputs: {
          stopped: "stopped"
        },
        decls: 3,
        vars: 1,
        consts: [[1, "fancy-timer", "ac-flex", "ac-gap-xs"], [1, "countdown-timer"], [1, "fancy-timer-block", "ac-flex-col", "ac-ctr"], [1, "ac-title-md"], [1, "ac-title-sm", "ac-label"]],
        template: function CountdownTimerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, CountdownTimerComponent_Case_0_Template, 9, 4, "div", 0)(1, CountdownTimerComponent_Case_1_Template, 4, 4)(2, CountdownTimerComponent_Case_2_Template, 6, 4, "div", 1);
          }
          if (rf & 2) {
            let tmp_0_0;
            i0.ɵɵconditional((tmp_0_0 = ctx.mode()) === "fancy" ? 0 : tmp_0_0 === "abbreviations" ? 1 : 2);
          }
        },
        styles: [".fancy-timer-block[_ngcontent-%COMP%]{width:54px;height:54px;background-color:var(--mat-sys-surface-container-high);border-radius:var(--ac-border-radius-md)}"],
        changeDetection: 0
      });
    }
  }
  return CountdownTimerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const ICON_KEYS = ['brand:gamergains', 'brand:gamergains_text', 'brand:gains', 'brand:gains_filled', 'brand:gains_full', 'brand:gains_text', 'brand:beta_tag', 'hr:circle_placeholder',
// TODO: REMOVE THIS ONCE WE HAVE ALL ICONS SET IN WEB
'hr:18_plus', 'hr:add_friends', 'hr:arrow_left', 'hr:arrow_right', 'hr:arrow_right_circle', 'hr:arrow_up_right', 'hr:arrow_up_down_circle', 'hr:arrow_down_left', 'hr:arrow_up_right_circle', 'hr:bank', 'hr:bell', 'hr:blackjack', 'hr:bolt', 'hr:boost', 'hr:browse', 'hr:calendar', 'hr:card', 'hr:chat_bubble', 'hr:checkmark', 'hr:checkmark_circle', 'hr:chevron_down', 'hr:chevron_left', 'hr:chevron_right', 'hr:chevron_up', 'hr:chevron_up_down', 'hr:clock', 'hr:collapse', 'hr:copy', 'hr:dealer', 'hr:dice', 'hr:document', 'hr:dollar_circle', 'hr:double', 'hr:ellipsis_horizontal', 'hr:ellipsis_vertical', 'hr:envelope', 'hr:external_link', 'hr:eye', 'hr:eye_slash', 'hr:featured_provider', 'hr:filter', 'hr:flame', 'hr:game_shows', 'hr:gift', 'hr:gift_circle', 'hr:high_volume', 'hr:hit', 'hr:home', 'hr:info', 'hr:low_volume', 'hr:menu', 'hr:mute_volume', 'hr:no_volume', 'hr:package', 'hr:people', 'hr:pencil', 'hr:photo_stack', 'hr:poker_chip', 'hr:plus_circle', 'hr:providers', 'hr:question_mark', 'hr:refresh', 'hr:rocket', 'hr:search', 'hr:security_shield', 'hr:settings', 'hr:sign_out', 'hr:slider', 'hr:slots', 'hr:split', 'hr:stand', 'hr:support', 'hr:table_games', 'hr:tasks', 'hr:top_up', 'hr:transactions', 'hr:upload', 'hr:us_flag', 'hr:user', 'hr:user_circle', 'hr:vip', 'hr:vip_level', 'hr:wallet', 'hr:warning', 'hr:xmark', 'hr:xmark_circle', 'provider:gamergains', 'provider:3_oaks_gaming', 'provider:betsoft', 'provider:boldplay', 'provider:caleta', 'provider:evolution', 'provider:gains', 'provider:gaming_corps', 'provider:habanero', 'provider:hacksaw_gaming', 'provider:kalamba', 'provider:onlyplay', 'provider:pragmatic_play', 'provider:relax_gaming', 'provider:rubyplay', 'provider:spinoro', 'currency:bitcoin', 'currency:ethereum', 'currency:gold_coins', 'currency:gold_coins_colorless', 'currency:polygon', 'currency:solana', 'currency:sweeps_cash', 'currency:usdc', 'currency:usdt', 'currency:arbitrum', 'currency:optimism', 'currency:base', 'currency:avalanche', 'currency:unichain', 'currency:tron', 'social:apple', 'social:discord', 'social:facebook_color', 'social:facebook', 'social:instagram', 'social:telegram', 'social:tiktok', 'social:x', 'social:youtube', 'social:google_color', 'game:card_suit_club', 'game:card_suit_diamond', 'game:card_suit_heart', 'game:card_suit_spade', 'game:blackjack_hit', 'game:blackjack_stand', 'game:blackjack_split', 'game:blackjack_double', 'payment:apple_pay', 'payment:amex', 'payment:bank_account', 'payment:coins_1', 'payment:coins_2', 'payment:coins_3', 'payment:coins_4', 'payment:coins_5', 'payment:coins_6', 'payment:discover', 'payment:ethereum', 'payment:external_link', 'payment:fail', 'payment:google_pay', 'payment:header_progress_step', 'payment:lightning', 'payment:mastercard', 'payment:pending', 'payment:success', 'payment:usdc', 'payment:visa', 'payment:warning', 'payment:debit_credit_card', 'payment:qr_code', 'payment:transactions', 'payment:transactions_circle', 'payment:sc_gc'];
let IconRegistryService = /*#__PURE__*/(() => {
  class IconRegistryService {
    constructor(_matIconRegistry, _domSanitizer) {
      this._matIconRegistry = _matIconRegistry;
      this._domSanitizer = _domSanitizer;
    }
    registerIcons(isProduction) {
      const cdnHost = isProduction ? `https://cdn.ripabet.com` : `https://cdn.ripabet-staging.com`;
      ICON_KEYS.forEach(iconKey => {
        const [set, icon] = iconKey.split(':');
        this._registerIcon(cdnHost, icon, `${icon}.svg`, set);
      });
    }
    _registerIcon(cdnHost, iconKey, iconFileName, set) {
      this._matIconRegistry.addSvgIconInNamespace(set, iconKey, this._domSanitizer.bypassSecurityTrustResourceUrl(`${cdnHost}/icons/${set ? set + '/' : '/'}${iconFileName}`));
    }
    static {
      this.ɵfac = function IconRegistryService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IconRegistryService)(i0.ɵɵinject(i1$2.MatIconRegistry), i0.ɵɵinject(i2.DomSanitizer));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IconRegistryService,
        factory: IconRegistryService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return IconRegistryService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InfiniteScrollComponent = /*#__PURE__*/(() => {
  class InfiniteScrollComponent {
    constructor(_cdr) {
      this._cdr = _cdr;
      this.viewport = null;
      this.itemTemplate = null;
      this.itemDef = null;
      this.itemHeight = 0;
      this.getBatch$ = () => of([]);
      this.templateCacheSize = 20;
      this.minBufferPx = 100;
      this.maxBufferPx = 200;
      this.height = 0;
      this.flex = false;
      this.sortDynamically = false;
      this.disableInfScrolling = false;
      this.transform = null;
      this.loadingBatch = false;
      this.showEnd = false;
      this.dataArr = [];
      this._data$ = of([]);
      this._dataSubscription = Subscription.EMPTY;
      this._offset = new BehaviorSubject(null);
      this.trackByFn = (index, item) => {
        return item[this.itemDef.idProp];
      };
    }
    ngOnChanges(changes) {
      if (changes['getBatch$'] && !changes['getBatch$'].isFirstChange() || changes['itemDef'] && !changes['itemDef'].isFirstChange()) {
        this.dataArr = [];
        this._offset.next(null);
      }
    }
    ngOnInit() {
      this._initData();
    }
    ngOnDestroy() {
      this._dataSubscription.unsubscribe();
    }
    nextBatch(scrollIndex, data) {
      if (!data || !data.length) {
        return;
      }
      if (this.disableInfScrolling) {
        this.showEnd = true;
        return;
      }
      const offsets = [];
      this.itemDef.offsetProps.forEach(offsetProp => {
        offsets.push(data[data.length - 1]?.[offsetProp]);
      });
      const end = this.viewport.getRenderedRange().end;
      const total = this.viewport.getDataLength();
      if (end === total) {
        this._offset.next(offsets);
      }
    }
    _initData() {
      const batchMap = this._offset.pipe(throttleTime(350), tap(() => {
        this.loadingBatch = true;
        this._cdr.markForCheck();
      }), mergeMap(n => this.getBatch$(n)), tap(arr => {
        if (!arr.length) {
          this.showEnd = true;
        }
      }), map(batch => batch.reduce((acc, curr) => ({
        ...acc,
        [curr[this.itemDef.idProp]]: curr
      }), {})), scan((acc, batch) => {
        return {
          ...acc,
          ...batch
        };
      }, {}));
      this._data$ = batchMap.pipe(map(v => Object.values(v)));
      this._dataSubscription = this._data$.pipe(tap(dataArr => {
        if (this.sortDynamically && this.itemDef.sortDynamicFn) {
          this.dataArr = dataArr.sort((a, b) => this.itemDef.sortDynamicFn(a, b));
        }
        if (this.transform) {
          this.dataArr = this.transform(dataArr);
        } else {
          this.dataArr = dataArr;
        }
        this.loadingBatch = false;
        this._cdr.markForCheck();
      })).subscribe();
    }
    static {
      this.ɵfac = function InfiniteScrollComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InfiniteScrollComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: InfiniteScrollComponent,
        selectors: [["ac-infinite-scroll"]],
        viewQuery: function InfiniteScrollComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(CdkVirtualScrollViewport, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.viewport = _t.first);
          }
        },
        inputs: {
          itemTemplate: "itemTemplate",
          itemDef: "itemDef",
          itemHeight: "itemHeight",
          getBatch$: "getBatch$",
          templateCacheSize: "templateCacheSize",
          minBufferPx: "minBufferPx",
          maxBufferPx: "maxBufferPx",
          height: "height",
          flex: "flex",
          sortDynamically: "sortDynamically",
          disableInfScrolling: "disableInfScrolling",
          transform: "transform"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c6,
        decls: 5,
        vars: 11,
        consts: [["visibility", "visible", "externalViewport", "", "cdkVirtualScrollViewport", "", 1, "infinite-scroll"], [3, "scrolledIndexChange", "itemSize", "minBufferPx", "maxBufferPx"], [4, "cdkVirtualFor", "cdkVirtualForOf", "cdkVirtualForTemplateCacheSize", "cdkVirtualForTrackBy"], [1, "infinite-scroll__end"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "size"]],
        template: function InfiniteScrollComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c5);
            i0.ɵɵelementStart(0, "ng-scrollbar", 0)(1, "cdk-virtual-scroll-viewport", 1);
            i0.ɵɵlistener("scrolledIndexChange", function InfiniteScrollComponent_Template_cdk_virtual_scroll_viewport_scrolledIndexChange_1_listener($event) {
              return ctx.nextBatch($event, ctx.dataArr);
            });
            i0.ɵɵtemplate(2, InfiniteScrollComponent_ng_container_2_Template, 2, 4, "ng-container", 2);
            i0.ɵɵconditionalCreate(3, InfiniteScrollComponent_Conditional_3_Template, 2, 1, "div", 3)(4, InfiniteScrollComponent_Conditional_4_Template, 3, 1, "div", 3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("flex-height", ctx.flex);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("height", ctx.height, "px");
            i0.ɵɵproperty("itemSize", ctx.itemHeight)("minBufferPx", ctx.minBufferPx)("maxBufferPx", ctx.maxBufferPx);
            i0.ɵɵadvance();
            i0.ɵɵproperty("cdkVirtualForOf", ctx.dataArr)("cdkVirtualForTemplateCacheSize", ctx.templateCacheSize)("cdkVirtualForTrackBy", ctx.trackByFn);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.loadingBatch ? 3 : ctx.showEnd ? 4 : -1);
          }
        },
        dependencies: [NgTemplateOutlet, CdkVirtualScrollViewport, CdkFixedSizeVirtualScroll, CdkVirtualForOf, NgScrollbarModule, i1$3.NgScrollbarExt, NgScrollbarCdkVirtualScroll, LoadingComponent],
        styles: [".infinite-scroll[_ngcontent-%COMP%]{width:100%;min-height:500px;--_viewport-padding-top: 0;--_viewport-padding-bottom: 0;--_viewport-padding-left: 0;--_viewport-padding-right: 0}.infinite-scroll.flex-height[_ngcontent-%COMP%]{flex:1;min-height:300px;height:100%}.infinite-scroll__end[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;min-height:100px}"],
        changeDetection: 0
      });
    }
  }
  return InfiniteScrollComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InfiniteScrollEmptyComponent = /*#__PURE__*/(() => {
  class InfiniteScrollEmptyComponent {
    constructor() {}
    static {
      this.ɵfac = function InfiniteScrollEmptyComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InfiniteScrollEmptyComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: InfiniteScrollEmptyComponent,
        selectors: [["ac-infinite-scroll-empty"]],
        ngContentSelectors: _c4,
        decls: 1,
        vars: 0,
        template: function InfiniteScrollEmptyComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return InfiniteScrollEmptyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InfiniteScrollEndComponent = /*#__PURE__*/(() => {
  class InfiniteScrollEndComponent {
    constructor() {}
    static {
      this.ɵfac = function InfiniteScrollEndComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InfiniteScrollEndComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: InfiniteScrollEndComponent,
        selectors: [["ac-infinite-scroll-end"]],
        ngContentSelectors: _c4,
        decls: 1,
        vars: 0,
        template: function InfiniteScrollEndComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
          }
        },
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return InfiniteScrollEndComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SingleSelectComponent = /*#__PURE__*/(() => {
  class SingleSelectComponent {
    constructor() {
      this.value = '';
      this.selected = new EventEmitter();
      this.isSelected = false;
      this.stretch = false;
    }
    static {
      this.ɵfac = function SingleSelectComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SingleSelectComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SingleSelectComponent,
        selectors: [["ac-single-select"]],
        inputs: {
          value: "value"
        },
        outputs: {
          selected: "selected"
        },
        ngContentSelectors: _c4,
        decls: 2,
        vars: 4,
        consts: [["mat-stroked-button", "", "type", "button", 1, "ac-single-select", 3, "click", "ngClass"]],
        template: function SingleSelectComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵlistener("click", function SingleSelectComponent_Template_button_click_0_listener() {
              return ctx.selected.emit(ctx.value);
            });
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(1, _c8, ctx.isSelected, ctx.stretch));
          }
        },
        dependencies: [NgClass, MatButton],
        styles: ["[_nghost-%COMP%]:has(>.ac-single-select.stretch){flex:1}.ac-single-select[_ngcontent-%COMP%]{background:var(--ac-tint-lower);--mat-button-outlined-label-text-color: var(--mat-sys-on-surface)}.ac-single-select.is-selected[_ngcontent-%COMP%]{--mat-button-outlined-outline-color: var(--mat-sys-inverse-primary);--mat-button-outlined-label-text-color: var(--mat-sys-inverse-primary)}.ac-single-select.stretch[_ngcontent-%COMP%]{width:100%}"]
      });
    }
  }
  return SingleSelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SingleSelectGroupComponent = /*#__PURE__*/(() => {
  class SingleSelectGroupComponent {
    constructor(_cdr) {
      this._cdr = _cdr;
      this.stretchButtons = false;
      this.selectedValue = null;
      this.selectedValueChange = new EventEmitter();
      this._singleSelectSubscriptions = [];
    }
    ngOnChanges(changes) {
      const selectedValueChanges = changes['selectedValue'];
      if (!selectedValueChanges.firstChange && selectedValueChanges.previousValue !== selectedValueChanges.currentValue) {
        this.syncRadioButtons();
      }
    }
    ngAfterViewInit() {
      this._singleSelectSubscriptions = this.singleSelectComponents.map(radioButton => {
        // Avoid ExpressionChangedAfterItHasBeenCheckedError
        setTimeout(() => {
          radioButton.stretch = this.stretchButtons;
          radioButton.isSelected = radioButton.value === this.selectedValue;
          this._cdr.markForCheck();
        });
        return radioButton.selected.subscribe(value => {
          if (this.selectedValue !== value) {
            this.selectedValue = value;
            this.selectedValueChange.emit(value);
            this.syncRadioButtons();
            this._cdr.markForCheck();
          }
        });
      });
    }
    ngOnDestroy() {
      this._singleSelectSubscriptions.forEach(sub => sub.unsubscribe());
    }
    syncRadioButtons() {
      this.singleSelectComponents.forEach(rb => {
        rb.isSelected = rb.value === this.selectedValue;
      });
    }
    static {
      this.ɵfac = function SingleSelectGroupComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SingleSelectGroupComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SingleSelectGroupComponent,
        selectors: [["ac-single-select-group"]],
        contentQueries: function SingleSelectGroupComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, SingleSelectComponent, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.singleSelectComponents = _t);
          }
        },
        inputs: {
          stretchButtons: "stretchButtons",
          selectedValue: "selectedValue"
        },
        outputs: {
          selectedValueChange: "selectedValueChange"
        },
        features: [i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c10,
        decls: 2,
        vars: 0,
        consts: [[1, "ac-single-select-group"]],
        template: function SingleSelectGroupComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c9);
            i0.ɵɵdomElementStart(0, "div", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵdomElementEnd();
          }
        },
        styles: [".ac-single-select-group[_ngcontent-%COMP%]{display:flex;gap:var(--ac-spacing-lg)}@media (max-width: 599px){.ac-single-select-group[_ngcontent-%COMP%]{gap:var(--ac-spacing-sm)}}"],
        changeDetection: 0
      });
    }
  }
  return SingleSelectGroupComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SkeletonComponent = /*#__PURE__*/(() => {
  class SkeletonComponent {
    constructor() {
      this._width = '20px';
      this._height = '20px';
      this._borderRadius = '8px';
      this._marginTop = '0';
      this._marginRight = '0';
      this._marginBottom = '0';
      this._marginLeft = '0';
    }
    set width(value) {
      this._width = typeof value === 'number' ? `${value}px` : value;
    }
    set height(value) {
      this._height = typeof value === 'number' ? `${value}px` : value;
    }
    set borderRadius(value) {
      this._borderRadius = typeof value === 'number' ? `${value}px` : value;
    }
    set marginTop(value) {
      this._marginTop = typeof value === 'number' ? `${value}px` : value;
    }
    set marginRight(value) {
      this._marginRight = typeof value === 'number' ? `${value}px` : value;
    }
    set marginBottom(value) {
      this._marginBottom = typeof value === 'number' ? `${value}px` : value;
    }
    set marginLeft(value) {
      this._marginLeft = typeof value === 'number' ? `${value}px` : value;
    }
    static {
      this.ɵfac = function SkeletonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SkeletonComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SkeletonComponent,
        selectors: [["ac-skeleton"]],
        inputs: {
          width: "width",
          height: "height",
          borderRadius: "borderRadius",
          marginTop: "marginTop",
          marginRight: "marginRight",
          marginBottom: "marginBottom",
          marginLeft: "marginLeft"
        },
        decls: 1,
        vars: 14,
        consts: [[1, "skeleton"]],
        template: function SkeletonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵdomElement(0, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("width", ctx._width)("height", ctx._height)("margin-top", ctx._marginTop)("margin-right", ctx._marginRight)("margin-bottom", ctx._marginBottom)("margin-left", ctx._marginLeft)("border-radius", ctx._borderRadius);
          }
        },
        styles: ["[_nghost-%COMP%]{display:contents}.skeleton[_ngcontent-%COMP%]{display:inline-block;height:1em;position:relative;overflow:hidden;background-color:#1f1f24;border-radius:var(--ac-border-radius-sm)}.skeleton[_ngcontent-%COMP%]:after{position:absolute;inset:0;transform:translate(-100%);background-image:linear-gradient(90deg,#80808000 0,#80808033 20%,#80808080 60%,#80808000);animation:_ngcontent-%COMP%_shimmer 1.5s infinite;content:\"\"}@keyframes _ngcontent-%COMP%_shimmer{to{transform:translate(100%)}}"]
      });
    }
  }
  return SkeletonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of storybook
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AlertService, AlertType, ButtonLoadingDirective, CardActionsComponent, CardComponent, CardContentComponent, CardHeaderComponent, CopyComponent, CountdownTimerComponent, DeviceService, DialogService, ICON_KEYS, IconComponent, IconRegistryService, InfiniteScrollComponent, InfiniteScrollEmptyComponent, InfiniteScrollEndComponent, LoadingComponent, SingleSelectComponent, SingleSelectGroupComponent, SkeletonComponent, fadeAnimation, isDescendant };
